import styled, { css } from 'styled-components'

import ColorPalette from '../../styles/colorPalette'

import { ScrollBarProps } from './ScrollBar.type'

const upArrow = `"data:image/svg+xml, <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.81374 3.63923L9.87054 7.91876C10.3433 8.58063 9.87018 9.5 9.05681 9.5L2.94319 9.5C2.12982 9.5 1.65669 8.58063 2.12946 7.91876L5.18627 3.63923C5.58509 3.08088 6.41491 3.08088 6.81374 3.63923Z' fill='%2345586B'/></svg>"`
const downArrow = `"data:image/svg+xml, <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M5.18627 8.36077L2.12946 4.08124C1.65669 3.41937 2.12982 2.5 2.94319 2.5H9.05681C9.87018 2.5 10.3433 3.41937 9.87054 4.08124L6.81373 8.36077C6.41491 8.91912 5.58509 8.91912 5.18627 8.36077Z' fill='%2345586B'/></svg>"`
const leftArrow = `"data:image/svg+xml, <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.63923 5.18627L7.91876 2.12946C8.58063 1.65669 9.5 2.12982 9.5 2.94319L9.5 9.05681C9.5 9.87018 8.58063 10.3433 7.91876 9.87054L3.63923 6.81373C3.08088 6.41491 3.08088 5.58509 3.63923 5.18627Z' fill='%2345586B'/></svg>"`
const rightArrow = `"data:image/svg+xml, <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M8.36077 6.81373L4.08124 9.87054C3.41937 10.3433 2.5 9.87018 2.5 9.05681L2.5 2.94319C2.5 2.12982 3.41937 1.65669 4.08124 2.12946L8.36077 5.18627C8.91912 5.58509 8.91912 6.41491 8.36077 6.81373Z' fill='%2345586B'/></svg>"`

export const baseScrollBar = css`
  /* Regular size by default */
  --handle-width: 5px;
  --track-width: 9px;

  /* Standard */
  @media screen and (min--moz-device-pixel-ratio: 0) {
    scrollbar-color: ${ColorPalette.Gray_0_3} ${ColorPalette.LightGray_0_1_5};
  }

  /* Chrome / Safari */
  ::-webkit-scrollbar {
    width: var(--track-width);
    height: var(--track-width);
    background-color: ${ColorPalette.LightGray_0_1_5};
    border-radius: var(--track-width);
    border: solid 1px ${ColorPalette.Gray_0_3};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${ColorPalette.Gray_0_3};
    border-radius: var(--track-width);
    border: solid 2px rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }

  ::-webkit-scrollbar-button {
    background-repeat: no-repeat;
    background-size: 7px;
    background-position: center;
  }

  ::-webkit-scrollbar-button:vertical:decrement {
    background-image: url(${upArrow});
  }

  ::-webkit-scrollbar-button:vertical:increment {
    background-image: url(${downArrow});
  }

  ::-webkit-scrollbar-button:horizontal:decrement {
    background-image: url(${leftArrow});
  }

  ::-webkit-scrollbar-button:horizontal:increment {
    background-image: url(${rightArrow});
  }
`

const heightClassMap = {
  'extra-small': css`
    --handle-width: 2px;
    --track-width: 6px;
  `,
  small: css`
    --handle-width: 3px;
    --track-width: 7px;
  `,
  'semi-small': css`
    --handle-width: 4px;
    --track-width: 8px;
  `,
  regular: css`
    --handle-width: 5px;
    --track-width: 9px;
  `,
  'semi-large': css`
    --handle-width: 6px;
    --track-width: 10px;
  `,
  large: css`
    --handle-width: 8px;
    --track-width: 12px;
  `,
  'extra-large': css`
    --handle-width: 10px;
    --track-width: 14px;
  `,
  'semi-giant': css`
    --handle-width: 12px;
    --track-width: 16px;
  `
}

const scrollModeMap = {
  all: css`
    overflow: auto;
  `,
  horizontal: css`
    overflow-y: hidden;
    overflow-x: auto;
  `,
  vertical: css`
    overflow-x: hidden;
    overflow-y: auto;
  `
}

export const Container = styled.div.withConfig<ScrollBarProps>({
  shouldForwardProp: (prop) =>
    !['mode', 'heightClass', 'scrollMode'].includes(prop)
})`
  ${baseScrollBar}

  ::-webkit-scrollbar-button {
    display: none;
  }

  ${({ mode }) =>
    mode == 'flexibe-size' &&
    css`
      ::-webkit-scrollbar-track-piece:start {
        background-color: ${ColorPalette.Gray_0_3};
        border-radius: var(--track-width);
        border: solid 2px rgba(0, 0, 0, 0);
        background-clip: padding-box;
      }
    `}

  ${({ heightClass = 'regular' }) => heightClassMap[heightClass]}

  min-height: 300px;

  ${({ scrollMode = 'all' }) => scrollModeMap[scrollMode]}
`

export const ForceOverflow = styled.div`
  width: 2000px;
  height: 1000px;
`
